import { useRegistrationFlowContext } from '@rhg/hooks/use-registration-context';
import {
    RegistrationFlowContextProps,
    RegistrationFlowContextState,
} from '@rhg/hooks/use-registration-context/types';
import { PropsWithChildren, createContext } from 'react';

export const RegistrationFlowContext =
    createContext<RegistrationFlowContextState>(undefined!);

export function RegistrationFlowProvider({
    children,
    ...props
}: PropsWithChildren<RegistrationFlowContextProps>) {
    const state = useRegistrationFlowContext(props);
    return (
        <RegistrationFlowContext.Provider value={state}>
            {children}
        </RegistrationFlowContext.Provider>
    );
}
